import * as React from 'react';
import { connect } from 'react-redux';
import defaultImage from 'src/assets/defaultImage';
import './ProductCardBox.scss';
import AddToListMenu from '../AddToListMenu';
import ProductModel from 'src/model/product.model';
import { partDetailUrl } from 'src/utils/navigation';
import { isMobile } from 'src/utils/responsiveHelpers';
import i18n from 'src/translation/i18n';
interface IFavoriteItem {
  key: string;
  value: number | string;
}
export interface IProductCardProps {
  part: ProductModel;
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
  id: string;
  name: string;
  category: string;
  mfc: string;
  description: string;
  price: number;
  msrp: number;
  image: string;
  state?: string;
  stateDescription?: string;
  favoritesArr: IFavoriteItem[];
  isFavoriteLoading?: boolean;
  favoriteLoadingItem?: string;
  inStock?: boolean;
  favorite?: boolean;
  favoriteId?: number;
  deal?: boolean;
  section?: boolean;
  brand?: string;
  viewDetails?: string;
  handleOnClicBuyNow(productId: string): void;
  handleToggleFavorite?(
    name: string,
    category:string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ): void;
  reloadPart?: () => void;
  t?: any;
}
interface IMobileState {
  isMobile: boolean;
  floatingIsOpen:boolean;
}

class ProductCardBox extends React.Component<IProductCardProps, IMobileState, any> {
  private flyMenuRef: any = null;

  constructor(props: any) {
    super(props);
    this.state = {
      floatingIsOpen: false,
      isMobile: isMobile()
    };
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public handleBlankClick = () => {
    return false;
  }
  /* 
    getStatus
   */
  private getStatus = (): {
    available: boolean;
    notLongerAvailable: boolean;
  } => {
    const { part } = this.props;
    const availableFlag = {
      available: false,
      notLongerAvailable: false
    };

    if (part.available) {
      availableFlag.available = true;

      if (
        part.partnerPrice === 0 ||
        (part.partnerPrice === 0.0 && part.retailPrice === 0) ||
        part.partnerPrice === 0.0
      ) {
        availableFlag.notLongerAvailable = false;
      }
    } else {
      availableFlag.available = false;
    }

    return availableFlag;
  };

  private renderStatus() {
    const availableFlag = this.getStatus();

    if (this.props.isLoggedIn) {
      if (availableFlag.notLongerAvailable) {
        return (
          <div className="rp-product-card-box--status">
            <span className="rp-product-card-box--status-container">
              <i className="rpds rpds-remove-circle" />
              <span>{i18n.t('common.noLongerAvailable')}</span>
            </span>
          </div>
        );
      } else {
        if (availableFlag.available) {
          return (
            <div className="rp-product-card-box--status">
              {this.props.inStock !== null &&
                (this.props.inStock ? (
                  <span className="rp-product-card-box--status-container">
                    <i
                      title={
                        this.props.stateDescription
                          ? this.props.stateDescription
                          : ''
                      }
                      className="rpds rpds-check-circle"
                    />
                    <span className='status-color-text'
                      title={
                        this.props.stateDescription
                          ? this.props.stateDescription
                          : ''
                      }
                    >
                      {/* {this.props.state} */}
                      {this.getStockStatus(this.props.state)}
                    </span>
                  </span>
                ) : (
                  <span className="rp-product-card-box--status-container">
                    <i
                      title={
                        this.props.stateDescription
                          ? this.props.stateDescription
                          : ''
                      }
                      className="rpds rpds-remove-circle"
                    />
                    <span className='status-red-text'
                      title={
                        this.props.stateDescription
                          ? this.props.stateDescription
                          : ''
                      }
                    >
                      {/* {this.props.state} */}
                      {this.getStockStatus(this.props.state)}
                    </span>
                  </span>
                ))}
              {this.props.part.specialOrder && (
                <span className="rp-product-card-box--status-container">
                  <i
                    title={'Special Order'}
                    className="rpds rpds-new-releases"
                  />
                  <span className='status-new-release-color-text' title={'Special Order'}>
                  {i18n.t('common.specialOrder')}
                  </span>
                </span>
              )}
            </div>
          );
        } else {
          return (
            <span className="rp-product-card-box--status-container">
              <i className="rpds rpds-remove-circle" />
              <span className='status-red-text'>{i18n.t('common.notAvailable')}</span>
            </span>
          );
        }
      }
    } else {
      return <React.Fragment />;
    }
  }

  /* 
    getPrices
   */
    private getPrices = () => {
      const availableFlag = this.getStatus();
      // this.props.price !== 0 && this.props.msrp !== 0 ? true : false;
      if (availableFlag.notLongerAvailable) {
        return <div className="rp-product-card--info-login empty-prices" />;
      } else {
        return this.props.isLoggedIn ? (
          <div className="rp-part-card--info-prices">
            <React.Fragment>
              <div className="price">
                <span className="label">
                  {(i18n.t('common.msrp') as string).toUpperCase()}
                </span>
                <p className='number'>${Number(this.props.msrp).toFixed(2)}</p>
              </div>
              {!this.props.showOnlyMSRP && (
                <div className="msrp">
                  <span className="label">
                    {i18n.t('myOrders.price')}
                  </span>
                  <p className="home-number">
                    ${Number(this.props.price).toFixed(2)}
                  </p>
                </div>
              )}
            </React.Fragment>
          </div>
        ) : (
          <div className="rp-part-card--info-login">
            {i18n.t('common.loginToViewPrices')}
          </div>
        );
      }
    };

  /* 
    getButtons
   */
    private getButtons = (favorite:boolean) => {
      const isPriceZero = Number(this.props.price) <= 0;
      const availableFlag = this.getStatus();
      let lng = 'en';
      const language = i18n.language;
      lng = language.split('-')[0];
      // this.props.price !== 0 && this.props.msrp !== 0 ? true : false;
  
      if (!availableFlag.available || availableFlag.notLongerAvailable) {
        return <div className="rp-product-card--empty-buttons" />;
      } else {
        return (
          <React.Fragment>
            <span
                tabIndex={isPriceZero ? -1 : 0}
                className={
                  lng === 'en'
                    ? `add-list-button ${isPriceZero ? 'disabled' : ''}`
                    : `add-list-button font-shrik-add-list ${isPriceZero ? 'disabled' : ''}`
                }
              >
              <AddToListMenu 
                direction="top"
                label={i18n.t('common.addToList')}
                height="36px"
                width="100%"
                part={this.props.part}
                category={this.props.category}
                mfc={this.props.mfc}
                favorite={favorite}
                reloadOrigin={this.props.reloadPart}
              />
            </span>
            <button
              className={
                lng === 'en'
                  ? 'primary-button buy-button'
                  : 'primary-button buy-button font-shrik-add-list'
              }
              onClick={() => {
                this.props.section
                  ? this.props.handleOnClicBuyNow(this.props.viewDetails)
                  : this.props.handleOnClicBuyNow(
                      `${this.props.mfc}  ${this.props.name}`
                    );
              }}
            >
              {i18n.t('common.buyNow')}
            </button>
          </React.Fragment>
        );
      }
    };


  private openMenu = () => {
    this.setState({ floatingIsOpen: true });
  };

  private closeMenu = () => {
    this.setState({ floatingIsOpen: false });
  };


  public shouldComponentUpdate() {
    return true;
  }

  public render() {
    const menuState = this.state.floatingIsOpen ? 'opened' : '';
    const foundFavoriteItem = this.props.favoritesArr.find(item => item.key === this.props.name);
    let favorite = this.props.favorite;
    const favoritStatus = foundFavoriteItem && foundFavoriteItem?.value !==1 && (typeof foundFavoriteItem?.value !== 'undefined' || foundFavoriteItem?.value !== undefined);
    if(favoritStatus) {
      favorite = true;
    } else if(foundFavoriteItem && foundFavoriteItem?.value ===1) {
      favorite = false;
    }
    return (
 
 <div className="rp-part-card-box  ">
   {
    this.props.favoriteLoadingItem === this.props.name &&
    this.props.isFavoriteLoading ? (
      <span className="starstyles star rpds spinner"/>
    ) : (
      this.props.isLoggedIn &&
      (
        favorite ? (
          <span
            className="starstyles star rpds rpds-star yellow"
            onClick={e =>
              this.props.handleToggleFavorite(
                this.props.name,
                this.props.category,
                this.props.mfc,
                favorite,
                (foundFavoriteItem &&
                  typeof foundFavoriteItem?.value === 'number' &&
                  foundFavoriteItem?.value !== 1)
                  ? foundFavoriteItem?.value
                  : this.props.favoriteId
              )
            }
          />
        ) : (
          <span
            className="starstyles star rpds rpds-star-border"
            onClick={e =>
              this.props.handleToggleFavorite(
                this.props.name,
                this.props.category,
                this.props.mfc,
                this.props.favorite,
                this.props.favoriteId
              )
            }
          />
        )
      )
    )
  }

  <div className="rp-product-card--top">
            {/* <span className="rp-product-card--deal">
              {i18n.t('common.onSale')}
            </span> */}
            <div aria-label={"Featured Part "+this.props.id}
              className={
                'image-container ' + (this.props.section && 'flyers-image')
              }
              style={{
                backgroundImage: `url(${
                  this.props.image !== '' ? 
                  this.props.image === 'undefined' ? defaultImage :
                  this.props.image : defaultImage
                })`
              }}
              onClick={() => {
                this.props.section
                  ? this.props.handleOnClicBuyNow(this.props.viewDetails)
                  : this.props.handleOnClicBuyNow(
                      `${this.props.mfc}  ${this.props.name}`
                    );
              }}
            />
          </div>
 <div className="rp-part-card--data-container" >
  <div className='rp-part-card--image'>
             
             <span
               className={
                 'image '
               }
               style={{
                 backgroundImage: `url(${
                   this.props.image !== '' ? this.props.image : defaultImage
                 })`
               }}
               onClick={() => {
                 this.props.section
                   ? this.props.handleOnClicBuyNow(this.props.viewDetails)
                   : this.props.handleOnClicBuyNow(
                       `${this.props.mfc}  ${this.props.name}`
                     );
               }}
             >
               {this.props.deal && !this.props.section ? (
               <span className="rp-product-card--deal">
                 {i18n.t('common.onSale')}
               </span>
             ) : null}
              </span>
             </div>
<div className="rp-part-card--data">
 <div className="data-container" 
  onClick={() => {
    this.state.isMobile ?
    this.handleBlankClick()
    :
    this.props.section
      ? this.props.handleOnClicBuyNow(this.props.viewDetails)
      : this.props.handleOnClicBuyNow(
          `${this.props.mfc}  ${this.props.name}`
        );
  }}
 >
 <div className="data--title-deal">
 <h1 className="data--title ">
 <span className="rp-highlight-background"/>{this.props.name}</h1></div>
 <dl>
  {
  this.props.description!==null && this.props.description.length >27 ?
  (
    this.state.isMobile ? (
      <span className="data--description" onClick={this.openMenu} >{this.props.description.slice(0,27)}...</span>
    ):
    <span className="data--description" onMouseOut={this.closeMenu} onMouseOver={this.openMenu}>{this.props.description.slice(0,27)}...</span>
  )  
  : (
    <span  className="data--description-short">{this.props?.description}</span>
  )
  }
  </dl>
 {/* Hover Description  */}
 <div className={`product-carrd-fly-description ${menuState}`} ref={ref => (this.flyMenuRef = ref)}>
     <div className="product-long-desc-item product-long-desc-cotainer">
      <div><span>{this.props?.description} </span></div>
      <div><span className="rpds-close close-button-product-card" onClick={this.closeMenu}/></div>
      </div> 
  </div>
 {/* End Hover Description  */}
 {this.renderStatus()}
 {this.getPrices()}
</div>

 </div>
</div>
<div className="rp-part-card--buttons-home">{this.getButtons(favorite)}</div>

</div>
    );
  }

  public getStockStatus(state: string): string {
    if (!state) {
      return state;
    }
    switch (state.toLowerCase()) {
      case 'in stock':
        return i18n.t('common.inStock');
      case 'out of stock':
        return i18n.t('common.outOfStock');
      case 'no longer available':
        return i18n.t('common.noLongerAvailable');
        break;
      case 'backorder':
        return i18n.t('myOrders.backOrder');
        break;
      case 'special order':
        return i18n.t('common.specialOrder');
        break;
      default:
        return state;
    }
  }
}

interface IStateFromProps {
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
}

const mapStateToProps = (state: any) => ({
  showOnlyMSRP: state.msrp.showOnlyMSRP,
  isLoggedIn: state.signin.success
});

export default connect<IStateFromProps, any, void>(mapStateToProps)(
  ProductCardBox
);
